/**
 *@author shaolei
 *@date 2020/04/02
 *@file_name:getPswd
 *@Description:修改密码
 */
<template>
  <div class="getPswd">
    <v-header></v-header>
    <div class="emptyheader"></div>
    <div class="pwd-layout">
      <div class="left">
        <img src="@/assets/images/login-left.png" alt="">
      </div>
      <div class="right">
        <div class="title">忘记密码</div>
        <div class="steps">
          <div class="steps_list">
            <div class="solid"></div>
            <div :class="step_index == 1 ? 'current' : step_index > 1 ? 'over' : ''" class="step">
              <div class="circle">1</div>
              <div class="name">验证身份</div>
            </div>
            <div :class="step_index == 2 ? 'current' : step_index > 2 ? 'over' : ''" class="step">
              <div class="circle">2</div>
              <div class="name">设置新密码</div>
            </div>
          </div>
        </div>
        <div class="middle">
          <el-form
            v-show="step_index == 1"
            ref="pswdForm_step1"
            :model="pswdForm_step1"
            :rules="rules"
            class="pswdForm1"
          >
            <el-form-item prop="phone">
              <div class="icon">
                <img src="@/assets/images/form-phone.png" alt="">
              </div>
              <el-input placeholder="请输入手机号" maxlength="11" v-model="pswdForm_step1.phone"></el-input>
            </el-form-item>
            <el-form-item prop="phoneCode">
              <div class="icon">
                <img src="@/assets/images/yzcode.png" alt="">
              </div>
              <el-input
                placeholder="请输入手机验证码"
                maxlength="6"
                v-model="pswdForm_step1.phoneCode"
                autocomplete="off"
              ></el-input>
              <p class="getYzCode" @click="getCode">
                <span v-if="sendMsgDisabled">{{ code_text }}</span>
                <span v-if="!sendMsgDisabled">{{this.second}} s</span>
              </p>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click.prevent="next()">下一步</el-button>
            </el-form-item>
          </el-form>
          <Verify
            @success="success"
            :mode="'pop'"
            :captchaType="'blockPuzzle'"
            :imgSize="{ width: '330px', height: '155px' }"
            ref="verify"
            v-if="isVerify"
          ></Verify>
          <!-- 第二步 -->
          <el-form
            v-show="step_index == 2"
            ref="pswdForm_step2"
            :model="pswdForm_step2"
            :rules="rules"
            class="success"
          >
            <el-form-item prop="newPswd">
              <div class="icon">
                <img src="@/assets/images/password.png" alt="">
              </div>
              <el-input
                placeholder="请设置6-16位数字、字母组合密码"
                type="password"
                maxlength="16"
                v-model="pswdForm_step2.newPswd"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item prop="newPswd1">
              <div class="icon">
                <img src="@/assets/images/password.png" alt="">
              </div>
              <el-input
                placeholder="请再次输入登录密码"
                type="password"
                maxlength="16"
                v-model="pswdForm_step2.newPswd1"
                autocomplete="off"
              ></el-input>
            </el-form-item>
            <el-form-item class="btn">
              <el-button @click.prevent="finish()">完成</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="qqTomanager">
           如果手机号已停用，请联系管理员更换手机号<br/>
           管理员QQ号: 49461751
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Verify from "@/components/verifition/Verify";
import vHeader from "@/layout/components/header";
import user from "@/apis/user_apis";
import { getPswdRules } from "@/validate/rules";
import utils from "@/utils/utils.js";
export default {
  data() {
    return {
      pswdForm_step1: {
        phone: "",
        phoneCode: "",
      },
      pswdForm_step2: {
        newPswd: "",
        newPswd1: ""
      },
      rules: getPswdRules,
      timer: null,
      second: 60,
      code_text: "发送验证码",
      sendMsgDisabled: true,
      step_index: 1, // 步骤索引
      show: true,
      isVerify: true,
      captcha:'',
      getuserCheck:{
        userName:'',
        checkCode:'',
      },
    };
  },
  created(){},
  mounted() {
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },
  methods: {
    success(params) {
      this.captcha = params.captchaVerification; //滑动验证码
      this.isVerify = false; //行为验证成功
      this.getMessageCode ();
    },
    /** 下一步 */
    next() {
      this.$refs.pswdForm_step1.validate(valid => {
        if (valid) {
          const query = {
            captcha: this.captcha,
            messageCode: this.pswdForm_step1.phoneCode,
            mobile:this.pswdForm_step1.phone,
          }
          user.rewritePswd(query).then(res => {
            if (res.success) {
              this.step_index = 2;
              const data = res.data;
              this.getuserCheck.checkCode = data.checkCode;
              this.getuserCheck.userName = data.userName;
            }
          });
        } else {
          return false;
        }
      });
    },
    /** 完成修改 */
    finish() {
      this.$refs.pswdForm_step2.validate(valid => {
        if (valid) {
          const newPswd = this.pswdForm_step2.newPswd;
          const query = Object.assign({newPswd},this.getuserCheck);
          query.mobile = this.pswdForm_step1.phone;
          user.resetpwd(query).then(res => {
            if (res.success) {
                this.$message.success("密码重置成功");
                this.$router.push({
                  path: "/index",
                });
                this.$toast(true);
            }
          });
        } else {
          return false;
        }
      });
    },
    /** 点击获取手机验证码按钮 */
    getCode() {
      this.$refs.pswdForm_step1.validateField("phone", (valid) => { 
        if (!valid) {
          if (this.sendMsgDisabled) {
            this.isVerify = true
            this.$nextTick(()=>{
              this.$refs.verify.show();
            })
          } else {
            return;
          }
        } else {
          return false;
        }
      });
    },
    // 获取短信验证码
    getMessageCode(){
        const query = {
          mobile:this.pswdForm_step1.phone,
          captcha:this.captcha,
          smsType:'retrieve',
        }
        user.sendsmscode(query).then(res => {
          if (res.success) {
            this.$message.success("短信发送成功！")
            this.sendMsgDisabled = false;
            this.timer = setInterval(() => {
              this.second--;
              if (this.second <= 0) {
                clearTimeout(this.timer);
                this.sendMsgDisabled = true;
                this.second = 60;
                this.code_text = "重新获取";
              }
            }, 1000);
          }
        });
    },
    /** 返回事件 */
    goBack() {
      if (this.step_index == 2) {
        this.step_index = 1;
      } else {
        history.back();
      }
    },
    
  },
  components: {
    vHeader,Verify
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  }
};
</script>

<style lang="less" scoped>
.getPswd {
  margin-bottom: 80px;
  
  .pwd-layout {
    box-shadow: 0px 3px 28px rgba(51, 51, 51, 0.06);
    border-radius: 0 40px 0 40px;
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    margin-top: 100px;
    display: flex;

    > div {
      flex-basis: 50%;
    }

    .left {
      background: #fabe00;
      border-radius: 0 0 0 40px;
      padding: 36px 14px 46px 27px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      .title {
        text-align: center;
        margin-top: 50px;
        color: #333333;
        font-size: 30px;
      }
      .steps {
        margin-top: 40px;

        .steps_list {
          display: flex;
          width: 300px;
          margin: 0 auto;
          justify-content: space-between;
          position: relative;

          .solid {
            position: absolute;
            z-index: -1;
            left: 30px;
            right: 30px;
            top: 9px;
            border-top: 1px dashed #ebebec;
          }

          .step {
            display: flex;
            flex-direction: column;
            align-items: center;

            .circle {
              box-sizing: border-box;
              width: 20px;
              height: 20px;
              background: #ebebec;
              border: 1px solid #ebebec;
              border-radius: 100%;
              font-size: 14px;
              color: #fff;
              text-align: center;
              line-height: 19px;
            }

            .name {
              font-size: 12px;
              color: #d7d7d7;
              margin-top: 10px;
            }
          }

          .current {
            .circle {
              background: #fff;
              color: #333333;
              border-color: #fabe00;
            }
            .name {
              color: #333333;
            }
          }

          .over {
            .circle {
              background: linear-gradient(
                180deg,
                rgba(250, 217, 0, 1) 0%,
                rgba(250, 190, 0, 1) 100%
              );
              color: #333333;
              border-color: #fabe00;
            }
            .name {
              color: #333333;
            }
          }
        }
      }
      .middle {
        width: 300px;
        margin: 0 auto;
        margin-top: 54px;

        .hint {
          display: flex;
          justify-content: space-between;
          margin-top: 22px;
          margin-bottom: 65px;
          color: #999999;
          font-size: 12px;
          cursor: pointer;

          .register {
            color: #fabe00;
          }
        }
        .el-form-item {
          height: 60px;
          margin-bottom: 0px !important;
          position: relative;

          .icon {
            position: absolute;
            z-index: 22;
            height: 35px;
            width: 30px;
            text-align: center;
            left: 0;
            bottom: 1px;

            img {
              max-width: 18px;
              max-height: 20px;
              margin-bottom: 11px;
            }
          }

          .last-icon {
            width: 23px;
            height: 14px;
            position: absolute;
            z-index: 22;
            bottom: 11px;
            right: 0;
          }
        }
        .getCode {
          position: absolute;
          right: 0;
          bottom: 8px;
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 36px;
          font-size: 14px;
          text-align: center;
          color: #fff;
          background: #9f9f9f;
          border-radius: 4px;
          cursor: pointer;
        }
        .getYzCode {
          position: absolute;
          right: 0;
          bottom: 8px;
          display: inline-block;
          width: 80px;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          text-align: center;
          color: #fabe00;
          background: rgba(250, 190, 0, 0.1);
          border: 1px solid rgba(250, 190, 0, 1);
          border-radius: 2px;
          cursor: pointer;
        }
        /deep/ .el-input__inner {
          height: 35px;
          border-radius: 0;
          border: none;
          border-bottom: 1px solid #e9e9f0;
          padding: 0 35px;
        }
        /deep/ .el-input__inner:focus {
          caret-color: #fabe00;
          border-bottom-color: #fabe00;
        }
        /deep/ .el-form-item__label {
          height: 50px !important;
          text-align: left !important;
          line-height: 50px !important;
          border-bottom: 1px solid #e9e9f0 !important;
        }
        .btn {
          margin-top: 20px;
          height: auto;

          /deep/ .el-form-item__content {
            margin-left: 0 !important;
          }
        }

        /deep/ .el-button + .el-button {
          margin-left: 30px !important;
        }
        /deep/ .el-button {
          padding: 0;
          width: 300px;
          height: 41px;
          font-size: 14px;
          border: 1px solid rgba(250, 217, 0, 1);
          color: #333;
          font-weight: normal;
          border-radius: 2px;
          background: linear-gradient(
            90deg,
            rgba(250, 217, 0, 1) 0%,
            rgba(250, 190, 0, 1) 100%
          );
          box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
        }
        /deep/ .el-button:hover {
          color: #fff;
          background: rgba(252, 111, 25, 1);
          box-shadow: 0px 3px 12px rgba(250, 108, 0, 0.3);
        }
        /deep/ .el-checkbox__inner {
          border: 1px solid #808495;
        }
        /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
          border: 1px solid #dcdfe6;
        }

        .success {
          text-align: center;

          .img {
            width: 98px;
            height: 98px;
            margin: 0 auto;
          }

          .h3 {
            font-size: 16px;
            color: #333333;
            margin-top: 10px;
          }
          .h5 {
            font-size: 12px;
            color: #999999;
            margin-top: 5px;
          }

          .btn-defualt {
            display: inline-block;
            margin-top: 20px;
            width: 164px;
            height: 34px;
            color: #fabe00;
            font-size: 14px;
            border: 1px solid #fabe00;
            border-radius: 2px;
            line-height: 34px;
            cursor: pointer;
          }
        }
      }
      .qqTomanager{
        width: 295px;
        font-size: 14px;
        margin: 0 auto;
        color: #606266;
        padding-top: 20px;        
      }

    }
  }
}
</style>